import React from 'react';
import {
  Dialog,
  DialogContentText,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useDeleteActivity } from '../hooks/useActivityMutations';
import { ErrorAPI } from '@shared/components/ui/ErrorAPI';

// Extend dayjs with timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const useStyles = makeStyles((theme) => ({
  title: {
    display: 'flex',
    direction: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: theme.spacing(4),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  rowDate: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'space-around',
  },
  spacing: {
    marginRight: '2em',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
}));

export const DeleteModal = (props) => {
  const { openModal, handleCloseModal, activity } = props;
  const classes = useStyles();
  const deleteActivityMutation = useDeleteActivity();

  const handleSaveAndClose = () => {
    deleteActivityMutation.mutate(activity?.id, {
      onSuccess: () => {
        handleCloseModal();
      },
    });
  };

  return (
    <div>
      <Dialog open={openModal} onClose={handleCloseModal} aria-labelledby="form-dialog-title">
        <DialogTitle disableTypography>
          <Typography variant="h6" className={classes.title}>
            Supprimer l'activité suivante :
          </Typography>

          <IconButton aria-label="close" className={classes.closeButton} onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <ErrorAPI
          errorAPI={deleteActivityMutation.isError}
          setErrorAPI={() => deleteActivityMutation.reset()}
          message={'Un problème est survenu lors de la suppression, veuillez recharger la page ou réessayer plus tard.'}
        />
        <DialogContent dividers>
          {activity && (
            <DialogContentText>
              {activity.activity_type} du {dayjs.utc(activity.started_at).local().format('DD/MM/YYYY')} de {dayjs.utc(activity.started_at).local().format('HH:mm')} à{' '}
              {dayjs.utc(activity.ended_at).local().format('HH:mm')}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary" disabled={deleteActivityMutation.isPending}>
            Annuler
          </Button>
          <Button onClick={handleSaveAndClose} color="primary" disabled={deleteActivityMutation.isPending}>
            {deleteActivityMutation.isPending ? 'Suppression...' : 'Supprimer définitivement'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
